import { NgModule } from '@angular/core';
import {
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbTabsetModule,
  NbUserModule,
  NbRadioModule,
  NbSelectModule,
  NbListModule,
  NbIconModule,
  NbInputModule,
  NbStepperModule,
  NbSpinnerModule,
} from '@nebular/theme';
import { NgxEchartsModule } from 'ngx-echarts';

import { ThemeModule } from '../../@theme/theme.module';
import { DashboardComponent } from './dashboard.component';
import { StatusCardComponent } from './status-card/status-card.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMaskModule } from 'ngx-mask';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ModalSimulacaoComponent } from './modal-simulacao/modal-simulacao.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ModalInfoComponent } from './modal-info/modal-info.component';

@NgModule({
  imports: [
    FormsModule,
    ThemeModule,
    NbCardModule,
    NbUserModule,
    NbButtonModule,
    NbTabsetModule,
    NbActionsModule,
    NbRadioModule,
    NbSelectModule,
    NbListModule,
    NbIconModule,
    NbButtonModule,
    NgxEchartsModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    CommonModule,
    ReactiveFormsModule,
    NbTabsetModule,
    NbStepperModule,
    NbButtonModule,
    NbListModule,
    NbUserModule,
    NbCardModule,
    NbIconModule,
    NbInputModule,
    ThemeModule,
    NgxMaskModule.forRoot(),
    NgxDatatableModule,
    NbSpinnerModule,
    CurrencyMaskModule,
    NgxChartsModule,
    NgxSpinnerModule,
  ],
  declarations: [
    DashboardComponent,
    StatusCardComponent,
    ModalSimulacaoComponent,
    ModalInfoComponent,
  ],
  entryComponents:[
    ModalSimulacaoComponent,
    ModalInfoComponent,
  ]
})
export class DashboardModule { }
